// extracted by css-extract-rspack-plugin
export default {"button":"button-1xCPB"};